import React from "react";
import { Helmet } from "react-helmet";
import tw from "twin.macro";

const SubscribeButton = tw.button`text-sm mb-4 bg-blue-800 text-white py-2 px-3 rounded transition ease-in-out duration-300 hover:shadow-lg focus:shadow-lg hover:bg-blue-700 focus:bg-blue-700`;
const Input = tw.input`rounded text-sm p-2 w-full`;
const Label = tw.label`block text-sm text-white`;
const Select = tw.select`bg-white rounded text-sm p-2 w-full`;
const FormContainer = tw.div`space-y-4 mt-4 bg-blue-900 p-4 rounded`;
const ButtonGroup = tw.div`space-x-4`;
const FormText = tw.p`text-sm text-white`;

const SignUp = () => {
  return (
    <>
      <Helmet>
        {/*}
        <link
          href="//cdn-images.mailchimp.com/embedcode/classic-061523.css"
          rel="stylesheet"
          type="text/css"
        />
        <script
          type="text/javascript"
          src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"
        ></script>
        <script type="text/javascript">{`(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[5]='MMERGE5';ftypes[5]='dropdown';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';}(jQuery));var $mcj = jQuery.noConflict(true);`}</script>
  {*/}
      </Helmet>
      <div id="mc_embed_shell">
        <div id="mc_embed_signup">
          <form
            action="https://frontierscience.us9.list-manage.com/subscribe/post?u=f191c2e2f9d42fb7988824c52&amp;id=c8fd1215e0&amp;f_id=000ccae0f0"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            className="validate"
            target="_blank"
          >
            <FormContainer id="mc_embed_signup_scroll">
              <FormText className="indicates-required">
                All fields are required
              </FormText>
              <div className="mc-field-group">
                <Label htmlFor="mce-EMAIL">
                  Email Address
                </Label>
                <Input
                  type="email"
                  name="EMAIL"
                  id="mce-EMAIL"
                  required
                />
              </div>
              <div className="mc-field-group">
                <Label htmlFor="mce-FNAME">
                  First Name
                </Label>
                <Input
                  type="text"
                  name="FNAME"
                  id="mce-FNAME"
                  required
                />
              </div>
              <div className="mc-field-group">
                <Label htmlFor="mce-LNAME">
                  Last Name
                </Label>
                <Input
                  type="text"
                  name="LNAME"
                  id="mce-LNAME"
                  required
                />
              </div>
              <div className="mc-field-group">
                <Label htmlFor="mce-MMERGE5">
                  CP-CTNet Group
                </Label>
                <Select name="MMERGE5" className="required" id="mce-MMERGE5">
                  <option value="">-- select your CP-CTNet group --</option>
                  <option value="Affiliated Organization (AO)">
                    Affiliated Organization (AO)
                  </option>
                  <option value="Division of Cancer Prevention (DCP)">
                    Division of Cancer Prevention (DCP)
                  </option>
                  <option value="Data Management, Auditing, and Coordinating Center (DMACC)">
                    Data Management, Auditing, and Coordinating Center (DMACC)
                  </option>
                  <option value="Lead Academic Organization (LAO)">
                    Lead Academic Organization (LAO)
                  </option>
                  <option value="Other">Other</option>
                </Select>
              </div>
              <div>
              </div>
              <div id="mce-responses" className="clear">
                <div
                  className="response"
                  id="mce-error-response"
                  style={{display: "none"}}
                ></div>
                <div
                  className="response"
                  id="mce-success-response"
                  style={{display: "none"}}
                ></div>
              </div>
              <div
                aria-hidden="true"
                style={{ position: 'absolute', left: "-5000px"}}
              >
                <input
                  type="text"
                  name="b_f191c2e2f9d42fb7988824c52_c8fd1215e0"
                  tabIndex="-1"
                  value=""
                />
              </div>
              <ButtonGroup className="clear">
                <SubscribeButton
                  type="submit"
                  name="subscribe"
                  id="mc-embedded-subscribe"
                >Subscribe</SubscribeButton>
              </ButtonGroup>
            </FormContainer>
          </form>
        </div>
      </div>
    </>
  );
};

export default SignUp;
